<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isAuctionManager()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Lot Details</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
<section class="content">
<br>
<br>
<div class="row">

	<br>	<!-- main row for all icons  -->
	<div class="col-sm-4">
		<div class="card card-primary card-outline">
			<div class="card-body">
				<form @submit.prevent="updateLot" role="form" @keydown="form.onKeydown($event)">
					<div :class="['form-group', errors.name ? 'has-error' : '']">
              	<label>Name</label>
                <input type="number" name="name" class="form-control" v-model="form.name" placeholder="Enter the Name" min="1">
                <span v-if="errors.name" :class="['badge bg-danger']">Enter a valid name.</span>
              </div>
              <div :class="['form-group', errors.warehouse_id ? 'has-error' : '']">
								<label for="nf-category">Warehouse</label>
								<v-select v-model="form.warehouse_id" type="text" label="name" :options="warehouses" :reduce="warehouses => warehouses.id" name="warehouse" placeholder="Select Warehouse" :value="warehouses => warehouses.name" @input="setCurrency"></v-select>
								<span v-if="errors.warehouse_id" :class="['badge bg-danger']">Please select a warehouse.</span>
							</div>
							<div :class="['form-group', errors.type ? 'has-error' : '']">
								<label for="nf-type">Type</label>
								<v-select v-model="form.type" type="text" label="name" :options="types" :reduce="types => types.name" name="type" placeholder="Select Type" @input="getSubTypes"></v-select>
								<span v-if="errors.type" :class="['badge bg-danger']">Please select a type.</span>
							</div>
							<div :class="['form-group', errors.subtype ? 'has-error' : '']">
								<label for="nf-subtype">Sub Type</label>
								<v-select v-model="form.subtype" type="text" label="name" :options="subtypes" :reduce="subtypes => subtypes.name" name="subtype" placeholder="Select Sub Type" @input="getTemplate"></v-select>
								<span v-if="errors.subtype" :class="['badge bg-danger']">Please select a sub type.</span>
							</div>

              <div :class="['form-group', errors.color_id ? 'has-error' : '']">
								<label for="nf-category">Color</label>
								<v-select v-model="form.color_id" type="text" label="name" :options="colors" :reduce="colors => colors.id" name="color" placeholder="Select Color" :value="colors => colors.name" @input="setCurrency"></v-select>
								<span v-if="errors.color_id" :class="['badge bg-danger']">Please select a color.</span>
							</div>
							<div :class="['form-check', errors.clean_lot ? 'has-error' : '']">
								<input v-model="form.clean_lot" class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
								<label class="form-check-label" for="flexCheckDefault">Clean Lot</label>
								<span v-if="errors.color_id" :class="['badge bg-danger']">Please select a color.</span>
							</div>
              <div :class="['form-group', errors.liter_weight ? 'has-error' : '']">
              	<label>Liter Weight</label>
                <input type="number" name="liter_weight" class="form-control" v-model="form.liter_weight" placeholder="Enter the Liter Weight" min="1" step="0.01" @input="setCurrency">
                <span v-if="errors.liter_weight" :class="['badge bg-danger']">Enter a valid liter weight.</span>
              </div>
              <div :class="['form-group', errors.moisture_content ? 'has-error' : '']">
              	<label>Moisture Content</label>
                <input type="number" name="moisture_content" class="form-control" v-model="form.moisture_content" placeholder="Enter the Moisture Content" min="1" step="0.01" @input="setCurrency">
                <span v-if="errors.moisture_content" :class="['badge bg-danger']">Enter a valid moisture content.</span>
              </div>
              <div :class="['form-group', errors.sample_weight ? 'has-error' : '']">
              	<label>Sample Weight</label>
                <input type="number" name="sample_weight" class="form-control" v-model="form.sample_weight" placeholder="Enter the Sample Weight" min="1" step="0.01" @input="setCurrency">
                <span v-if="errors.sample_weight" :class="['badge bg-danger']">Enter a valid sample weight.</span>
              </div>
              <div :class="['form-group', errors.net_weight ? 'has-error' : '']">
              	<label>Net Weight</label>
                <input type="number" name="net_weight" class="form-control" v-model="form.net_weight" placeholder="Enter the Net Weight" min="1" step="0.01" @input="setCurrency">
                <span v-if="errors.net_weight" :class="['badge bg-danger']">Enter a valid net weight.</span>
              </div>
              <div :class="['form-group', errors.gunny_bags ? 'has-error' : '']">
              	<label>Gunny bags</label>
                <input type="number" name="gunny_bags" class="form-control" v-model="form.gunny_bags" placeholder="Enter the number if gunny bags" min="1">
                <span v-if="errors.gunny_bags" :class="['badge bg-danger']">Enter a valid number.</span>
              </div>
							<div :class="['form-group', errors.loading_rate ? 'has-error' : '']">
              	<label>Loading Rate</label>
                <input type="number" name="loading_rate" class="form-control" v-model="form.loading_rate" placeholder="Enter the Loading Rate" min="1" @input="bagRateCalc">
                <span v-if="errors.loading_rate" :class="['badge bg-danger']">Enter a valid loading rate.</span>
              </div>
              <div :class="['form-group', errors.plastic_rate ? 'has-error' : '']">
              	<label>Plastic Rate</label>
                <input type="number" name="plastic_rate" class="form-control" v-model="form.plastic_rate" placeholder="Enter the Plastic Rate" min="1" @input="bagRateCalc">
                <span v-if="errors.plastic_rate" :class="['badge bg-danger']">Enter a valid plastic rate.</span>
              </div>
              <div :class="['form-group', errors.gunny_bags_rate ? 'has-error' : '']">
              	<label>Gunny Bags Rate</label>
                <input type="number" name="gunny_bags_rate" class="form-control" placeholder="Enter the Gunny Bags Rate" min="1" disabled :value="form.gunny_bags_rate">
                <span v-if="errors.gunny_bags_rate" :class="['badge bg-danger']">Enter a valid gunny bags rate.</span>
              </div>
              <div :class="['form-group', errors.quote_price ? 'has-error' : '']">
              	<label>Quote Price</label>
                <input type="number" name="quote_price" class="form-control" v-model="form.quote_price" placeholder="Enter the Quote Price" min="1">
                <span v-if="errors.quote_price" :class="['badge bg-danger']">Enter a valid quote price.</span>
              </div>
              <div :class="['form-group', errors.control_price ? 'has-error' : '']">
              	<label>Control Price</label>
                <input type="number" name="control_price" class="form-control" v-model="form.control_price" placeholder="Enter the Control Price" min="0">
                <span v-if="errors.control_price" :class="['badge bg-danger']">Enter a valid control price.</span>
              </div>
              <div :class="['form-group', errors.credit_by ? 'has-error' : '']">
              	<label>Days Credit</label>
                <select name="credit_by" class="form-control" v-model="form.credit_by">
                	<option v-for="discount in discounts" :value="discount.credit_by">Days Credit- {{discount.credit_by}}, Discount- {{discount.discount}}</option>
                </select>
                <span v-if="errors.credit_by" :class="['badge bg-danger']">Enter a valid number.</span>
              </div>
              <div :class="['form-group', errors.seller ? 'has-error' : '']">
								<label for="nf-category">Seller</label>
								<v-select v-model="form.seller_id" type="text" label="name" :options="sellers" :reduce="sellers => sellers.id" name="seller_id" placeholder="Select Seller" :value="sellers => sellers.id"></v-select>
								<span v-if="errors.seller_id" :class="['badge bg-danger']">Please select a seller.</span>
							</div>
							<div :class="['form-group', errors.nick_name ? 'has-error' : '']">
              	<label>Seller Nick Name</label>
                <input type="text" name="nick_name" class="form-control" v-model="form.nick_name" placeholder="Enter the seller nick name">
                <span v-if="errors.nick_name" :class="['badge bg-danger']">Enter a valid nick name.</span>
              </div>
							<div :class="['form-group', errors.description ? 'has-error' : '']">
              	<label>Description</label>
                <input type="text" name="description" class="form-control" v-model="form.description" placeholder="Enter the Description"  @input="setCurrency">
                <span v-if="errors.description" :class="['badge bg-danger']">Enter a valid description.</span>
              </div>
              <div :class="['form-group', errors.currency? 'has-error' : '']" style="display: none;">
              	<label>Currency</label>
                <input type="text" name="currency" class="form-control" v-model="form.currency" placeholder="Enter the Currency" value="INR">
                <span v-if="errors.currency" :class="['badge bg-danger']">Enter a valid currency.</span>
              </div>
              <div :class="['form-group', errors.time_limit ? 'has-error' : '']" style="display: none;">
              	<label>Time Limit</label>
                <input type="number" name="time_limit" class="form-control" v-model="form.time_limit" placeholder="Enter the Time Limit" min="1" @input="setCurrency">
                <span v-if="errors.time_limit" :class="['badge bg-danger']">Enter a valid time limit.</span>
              </div>
							<div class="form-group">
								<button type="submit" class="btn btn-primary">Submit</button>
							</div>
				</form>
			</div>
		</div>
	</div>
<div class="col-sm-8">
	<div class="col-md-12" v-if="row.length >= 1">
		<div class="card card-primary card-outline">
			<div class="card-body overflow-auto">
				<datatable style="margin-top:1%;" :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
      	<tbody>
        	<tr>
          		<td>{{row[0].row_name}}</td>
				<td>
					<input class="form-control forty" type="number" min="0" step="0.01" v-model="r1c1" @input="calculatePercentage('r1c1')">
				</td>
				<td>
					<input class="form-control forty" type="number" min="0" step="0.01" v-model="r1c2" @input="calculatePercentage('r1c2')">
				</td>
				<td>
					<input class="form-control forty" type="number" min="0" step="0.01" v-model="r1c3" @input="calculatePercentage('r1c3')">
				</td>
				<td v-if="form.subtype != 'Seed' && form.subtype != 'Pan'">
					<input class="form-control forty" type="number" min="0" step="0.01" v-model="r1c4" @input="calculatePercentage('r1c4')">
				</td>
				<td>
					{{totalr1}}
				</td>
          	</tr>
			  <tr v-if="form.subtype != 'Seed' && form.subtype != 'Pan'">
          		<td>{{row[1].row_name}}</td>
				<td>
					<input class="form-control forty" type="number" min="0" step="0.01" v-model="r2c1" @input="calculatePercentage('r2c1')">
				</td>
				<td>
					<input class="form-control forty" type="number" min="0" step="0.01" v-model="r2c2" @input="calculatePercentage('r2c2')">
				</td>
				<td>
					<input class="form-control forty" type="number" min="0" step="0.01" v-model="r2c3" @input="calculatePercentage('r2c3')">
				</td>
				<td v-if="form.subtype != 'Seed' && form.subtype != 'Pan'">
					<input class="form-control forty" type="number" min="0" step="0.01" v-model="r2c4" @input="calculatePercentage('r2c4')">
				</td>
				<td>
					{{totalr2}}
				</td>
          	</tr>
			  <tr v-if="form.subtype != 'Seed' && form.subtype != 'Pan'">
          		<td>{{row[2].row_name}}</td>
				<td>
					<input class="form-control forty" type="number" min="0" step="0.01" v-model="r3c1" @input="calculatePercentage('r3c1')">
				</td>
				<td>
					<input class="form-control forty" type="number" min="0" step="0.01" v-model="r3c2" @input="calculatePercentage('r3c2')">
				</td>
				<td>
					<input class="form-control forty" type="number" min="0" step="0.01" v-model="r3c3" @input="calculatePercentage('r3c3')">
				</td>
				<td v-if="form.subtype != 'Seed'">
					<input class="form-control forty" type="number" min="0" step="0.01" v-model="r3c4" @input="calculatePercentage('r3c4')">
				</td>
				<td>
					{{totalr3}}
				</td>
          	</tr>
			  <tr>
          		<th>Total</th>
				<td>
					{{totalc1}}
				</td>
				<td>
					{{totalc2}}
				</td>
				<td>
					{{totalc3}}
				</td>
				<td v-if="form.subtype != 'Seed' && form.subtype != 'Pan'">
					{{totalc4}}
				</td>
				<td>
					{{total}}
				</td>
          	</tr>
        </tbody>
      </datatable>
    </div>
    <div class="card-footer">
    	<button class="btn btn-primary" @click="addGrading">Submit</button>
			</div>
		</div>
	</div>

	<div class="col-md-12" v-if="row.length >= 1">
		<div class="card card-primary card-outline">
			<div class="card-body overflow-auto">

				<datatable style="margin-top:1%; margin-left:1%; margin-right:1%; margin-bottom:1%;" :columns="pcolumns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
      	<tbody>
        	<tr>
          		<td>{{row[0].row_name}}</td>
				<td>
					{{r1c1p}}
				</td>
				<td>
					{{r1c2p}}
				</td>
				<td>
					{{r1c3p}}
				</td>
				<td v-if="form.subtype != 'Seed' && form.subtype != 'Pan'">
					{{r1c4p}}
				</td>
				<td>
					<b>{{totalr1p}}</b>
				</td>
          	</tr>
			  <tr v-if="form.subtype != 'Seed' && form.subtype != 'Pan'">
          		<td>{{row[1].row_name}}</td>
				<td>
					{{r2c1p}}
				</td>
				<td>
					{{r2c2p}}
				</td>
				<td>
					{{r2c3p}}
				</td>
				<td>
					{{r2c4p}}
				</td>
				<td>
					<b>{{totalr2p}}</b>
				</td>
          	</tr>
			  <tr v-if="form.subtype != 'Seed' && form.subtype != 'Pan'">
          		<td>{{row[2].row_name}}</td>
				<td>
					{{r3c1p}}
				<td>
					{{r3c2p}}
				</td>
				<td>
					{{r3c3p}}
				</td>
				<td>
					{{r3c4p}}
				</td>
				<td>
					<b>{{totalr3p}}</b>
				</td>
          	</tr>
			  <tr>
          		<th>Total %</th>
				<td>
					<b>{{totalc1p}}</b>
				</td>
				<td>
					<b>{{totalc2p}}</b>
				</td>
				<td>
					<b>{{totalc3p}}</b>
				</td>
				<td v-if="form.subtype != 'Seed' && form.subtype != 'Pan'">
					<b>{{totalc4p}}</b>
				</td>
				<td>
					<b>{{totalp}}</b>
				</td>
          	</tr>
        </tbody>
      </datatable>
    </div>
		</div>
	</div>
	<div class="col-sm-12">
		<div class="card card-primary card-outline">
			<div class="card-body">
<!-- Image Here -->
				<img :src="url" alt="Lot Image" style="max-width: 100%;">
				<br>
				<div :class="['form-group', errors.image ? 'has-error' : '']">
					<label for="nf-image">Change Image</label>
					<input type="file" label="image" placeholder="Select Image" name="image" class="form-control" id="file" ref="file" @change="addFile">
					<span v-if="errors.image" :class="['badge bg-danger']">Please select a valid image.</span>
					<button type="button" class="btn btn-primary" @click="changeImage">Change Image</button>
				</div>
			</div>
		</div>
	</div>
	<div class="col-sm-12">
		<div class="card card-primary card-outline">
			<div class="card-body">
<!-- Image Here -->
				<div :class="['form-group', errors.auction_id ? 'has-error' : '']">
					<label for="nf-auction">Add to Auction</label>
					<v-select v-model="auction_id" type="text" label="auction_id" :options="auctions" :reduce="auctions => auctions.id" name="auction_id" placeholder="Select Auction" :value="auction => auction.id"></v-select>
					<span v-if="errors.auction_id" :class="['badge bg-danger']">Please select a valid auction.</span>
					<button type="button" class="btn btn-primary" @click="addLot">Add to Auction</button>
				</div>
			</div>
		</div>
	</div>
</div>

	</div>
	<!-- row end -->
</section>



<br>
      <br>
    <!-- /.content -->
</div>



<!-- All VUE Parts end before this comment -->

        <div v-if="!$gate.isAuctionManager()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		import Datatable from '../datatable.vue';
    import Pagination from '../pagination.vue';
    export default {
        mounted() {
            console.log('Component mounted.');
        },

        components: {datatable:Datatable, pagination:Pagination},

        created(){
        	this.getLotDetails();
        	//this.getQualities();
        	this.getGrades();
        	this.getLotGrades();
        	this.getColors();
        	this.getSellers();
        	this.getTypes();
        	this.getAuctions();
        	this.getWarehouses();
        	this.getDiscounts();
        	//this.incr++;
        },

        data(){
        	let sortOrders = {};
      		let columns = [
				  {width:'10%', label:"Grade/Quality", name:'value_mg'},

      		];
      		//columns.forEach((column) => {
          	//sortOrders[column.name]=-1;
        	//});

        	return {
        		columns: [
				  {width:'10%', label:"Grade/Quality", name:'value_mg'},

				  ],
				  pcolumns: [],
        		sortKey: 'id',
        		sortOrders: sortOrders,
        		tableData: {
        			draw: 0,
        			length: 10,
        			column: 0,
        			dir: 'desc'
        		},
        		pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
        		form: new Form({
        			name: '',
        		description: '',
        		liter_weight: '',
        		color_id: '',
        		net_weight: '',
        		currency: '',
        		quote_price: '',
        		control_price: '',
        		seller_id: '',
        		id: '',
        		type: '',
        		subtype: '',
        		sample_weight: '',
        		moisture_content: '',
        		time_limit: '',
        		gunny_bags: '',
        		image_url: '',
        		warehouse_id: '',
        		gunny_bags_rate: '',
        		credit_by: '',
        		clean_lot: '',
        		nick_name: '',
        		loading_rate: '',
        		plastic_rate: ''
        		}),
        		qualities: [],
        		grades: [],
        		lotGrades: [],
        		errors: [],
        		colors: [],
         		sellers: [],
         		types: [],
         		subtypes: [],
				row: [],
				values : [],
				r1c1: '',
				r1c2: '',
				r1c3: '',
				r1c4: '',
				r2c1: '',
				r2c2: '',
				r2c3: '',
				r2c4: '',
				r3c1: '',
				r3c2: '',
				r3c3: '',
				r3c4: '',
				r1c1p: '',
				r1c2p: '',
				r1c3p: '',
				r1c4p: '',
				r2c1p: '',
				r2c2p: '',
				r2c3p: '',
				r2c4p: '',
				r3c1p: '',
				r3c2p: '',
				r3c3p: '',
				r3c4p: '',
				totalc1: '',
				totalc2: '',
				totalc3: '',
				totalc4: '',
				totalr1: '',
				totalr2: '',
				totalr3: '',
				totalc1p: '',
				totalc2p: '',
				totalc3p: '',
				totalc4p: '',
				totalr1p: '',
				totalr2p: '',
				totalr3p: '',
				total: '',
				totalp: '',
				r1c1id: '',
				r1c2id: '',
				r1c3id: '',
				r1c4id: '',
				r2c1id: '',
				r2c2id: '',
				r2c3id: '',
				r2c4id: '',
				r3c1id: '',
				r3c2id: '',
				r3c3id: '',
				r3c4id: '',
				finalvalues: [],
				image: '',
				file: '',
				url: '',
				auctions: '',
				auction_id: '',
				warehouses: [],
				discounts: []
			}
		},

		methods: {
        	configPagination(data){
      		this.pagination.last_page=data.last_page;
         	this.pagination.currentPage=data.current_page;
    	  	this.pagination.total=data.total;
        	this.pagination.lastPageUrl=data.last_page_url;
       		this.pagination.nextPageUrl=data.next_page_url;
       		this.pagination.prevPageUrl=data.prev_page_url;
     		 	this.pagination.from=data.from;
        	this.pagination.to=data.to;
    		},

    		setCurrency(){
    			this.form.currency = "INR";
    		},

    		bagRateCalc(){
    			this.form.gunny_bags_rate = parseFloat(this.form.loading_rate) + parseFloat(this.form.plastic_rate) + parseFloat(this.form.plastic_rate * (18/100).toPrecision(2));
    		},

      	sortBy(key){
     			this.sortKey=key;
      		this.sortOrders[key] = this.sortOrders[key]*-1;
       	  this.tableData.column = this.getIndex(this.columns, 'name', key);
 	     	  this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
    		},

     		getIndex(array, key, value){
       		return array.findIndex(i => i[key] == value)
       	},
        	getGrades(url="/api/getGrades"){
       			axios.post(url)
       			.then(response => {
       				this.grades = response.data;
       				//this.configPagination(response.data.data);
       			})
       		},

       		getDiscounts(){
       			axios.post("/api/getDiscounts")
       			.then(response => {
       				this.discounts = response.data;
       			});
       		},

       		getQualities(url="/api/getQualities"){
       			this.columns = [{width:'10%', label:"Grade/Quality", name:'value_mg'}];
       			this.pcolumns = [];
       			axios.post(url, {subtype: this.form.subtype})
       			.then(response => {
       				this.qualities = response.data;
					   //this.configPagination(response.data.data);
					for(var i=0; i<this.qualities.length;i++){
						this.columns.push(
							{width: '10%', label: this.qualities[i].name, name: this.qualities[i].name}
						);
					}
					this.pcolumns = this.columns;
					this.columns.push(
							{width: '10%', label: "Total", name: "total"}
						);
       			})
       		},

       		getLotDetails(){
       			axios.post("/api/getLotDetails", {id: this.$route.params.id})
       			.then(response => {
       				this.form.fill(response.data);
       				if(this.form.subtype != null){
       					this.getTemplate();
       				}
       				this.url = this.form.image_url;
       			})
       		},

       		getLotGrades(){
       			this.form.lot_id = this.$route.params.id;
       			axios.post("/api/getLotGrades", {id: this.$route.params.id})
       			.then(response => {
       			if(response.data.length > 0){
       				if(this.form.subtype != 'Seed' && this.form.subtype != 'Pan'){
						this.r1c1 = response.data[0].value_mg;
						this.r1c2 = response.data[1].value_mg;
						this.r1c3 = response.data[2].value_mg;


							this.r1c4 = response.data[3].value_mg;
							this.r2c1 = response.data[4].value_mg;
							this.r2c2 = response.data[5].value_mg;
							this.r2c3 = response.data[6].value_mg;
							this.r2c4 = response.data[7].value_mg;
							this.r3c1 = response.data[8].value_mg;
							this.r3c2 = response.data[9].value_mg;
							this.r3c3 = response.data[10].value_mg;
							this.r3c4 = response.data[11].value_mg;


this.r1c1id = response.data[0].id;
this.r1c2id = response.data[1].id;
this.r1c3id = response.data[2].id;
this.r1c4id = response.data[3].id;
this.r2c1id = response.data[4].id;
this.r2c2id = response.data[5].id;
this.r2c3id = response.data[6].id;
this.r2c4id = response.data[7].id;
this.r3c1id = response.data[8].id;
this.r3c2id = response.data[9].id;
this.r3c3id = response.data[10].id;
this.r3c4id = response.data[11].id;

					this.calculatePercentage("none");

					}
					else{
						this.r1c1 = response.data[0].value_mg;
						this.r1c2 = response.data[1].value_mg;
						this.r1c3 = response.data[2].value_mg;

						this.r1c1id = response.data[0].id;
						this.r1c2id = response.data[1].id;
						this.r1c3id = response.data[2].id;

						this.calculateSeed('none');
					}
			}
       			})
       		},

       		addGrading(){
       			this.finalvalues.push({"grade":this.row[0].row_name, 'quality': this.qualities[0].name, 'value_mg': this.r1c1, 'id': this.r1c1id, 'value_percentage': this.r1c1p, 'lot_id': this.form.id, 'created_by': this.$userId, 'updated_by': this.$userId});
				this.finalvalues.push({"grade":this.row[0].row_name, 'quality': this.qualities[1].name, 'value_mg': this.r1c2, 'id': this.r1c2id, 'value_percentage': this.r1c2p, 'lot_id': this.form.id, 'created_by': this.$userId, 'updated_by': this.$userId});
				this.finalvalues.push({"grade":this.row[0].row_name, 'quality': this.qualities[2].name, 'value_mg': this.r1c3, 'id': this.r1c3id, 'value_percentage': this.r1c3p, 'lot_id': this.form.id, 'created_by': this.$userId, 'updated_by': this.$userId});

				if(this.form.subtype != 'Seed' && this.form.subtype != 'Pan'){

				this.finalvalues.push({"grade":this.row[0].row_name, 'quality': this.qualities[3].name, 'value_mg': this.r1c4, 'id': this.r1c4id, 'value_percentage': this.r1c4p, 'lot_id': this.form.id, 'created_by': this.$userId, 'updated_by': this.$userId});
				this.finalvalues.push({"grade":this.row[1].row_name, 'quality': this.qualities[0].name, 'value_mg': this.r2c1, 'id': this.r2c1id, 'value_percentage': this.r2c1p, 'lot_id': this.form.id, 'created_by': this.$userId, 'updated_by': this.$userId});
				this.finalvalues.push({"grade":this.row[1].row_name, 'quality': this.qualities[1].name, 'value_mg': this.r2c2, 'id': this.r2c2id, 'value_percentage': this.r2c2p, 'lot_id': this.form.id, 'created_by': this.$userId, 'updated_by': this.$userId});
				this.finalvalues.push({"grade":this.row[1].row_name, 'quality': this.qualities[2].name, 'value_mg': this.r2c3, 'id': this.r2c3id, 'value_percentage': this.r2c3p, 'lot_id': this.form.id, 'created_by': this.$userId, 'updated_by': this.$userId});
				this.finalvalues.push({"grade":this.row[1].row_name, 'quality': this.qualities[3].name, 'value_mg': this.r2c4, 'id': this.r2c4id, 'value_percentage': this.r2c4p, 'lot_id': this.form.id, 'created_by': this.$userId, 'updated_by': this.$userId});
				this.finalvalues.push({"grade":this.row[2].row_name, 'quality': this.qualities[0].name, 'value_mg': this.r3c1, 'id': this.r3c1id, 'value_percentage': this.r3c1p, 'lot_id': this.form.id, 'created_by': this.$userId, 'updated_by': this.$userId});
				this.finalvalues.push({"grade":this.row[2].row_name, 'quality': this.qualities[1].name, 'value_mg': this.r3c2, 'id': this.r3c2id, 'value_percentage': this.r3c2p, 'lot_id': this.form.id, 'created_by': this.$userId, 'updated_by': this.$userId});
				this.finalvalues.push({"grade":this.row[2].row_name, 'quality': this.qualities[2].name, 'value_mg': this.r3c3, 'id': this.r3c3id, 'value_percentage': this.r3c3p, 'lot_id': this.form.id, 'created_by': this.$userId, 'updated_by': this.$userId});
				this.finalvalues.push({"grade":this.row[2].row_name, 'quality': this.qualities[3].name, 'value_mg': this.r3c4, 'id': this.r3c4id, 'value_percentage': this.r3c4p, 'lot_id': this.form.id, 'created_by': this.$userId, 'updated_by': this.$userId});

				}

				axios.post("/api/updateGrading", {values: this.finalvalues, id:this.form.id, presence: this.r1c1id})
				.then(response => {
					if (response.status == 200){
						toast.fire({
							title: "Grading added",
							type: "success"
						});
						this.finalvalues = [];
						this.getLotGrades();
					}
					else{
						toast.fire({
							title: "Operation Failed",
							type: "error"
						});
						this.finalvalues = [];
					}
				})
				.catch(() => {
					toast.fire({
							title: "Operation Failed",
							type: "error"
						});
						this.finalvalues = [];
				})
		   },

       		calculatePercentage(cell){
       			if(this.form.subtype != 'Seed' && this.form.subtype != 'Pan'){
       			this.totalc1 = (parseFloat(this.r1c1)+parseFloat(this.r2c1)+parseFloat(this.r3c1)).toPrecision(4);
       			this.totalc2 = (parseFloat(this.r1c2)+parseFloat(this.r2c2)+parseFloat(this.r3c2)).toPrecision(4);
       			this.totalc3 = (parseFloat(this.r1c3)+parseFloat(this.r2c3)+parseFloat(this.r3c3)).toPrecision(4);
       			this.totalc4 = (parseFloat(this.r1c4)+parseFloat(this.r2c4)+parseFloat(this.r3c4)).toPrecision(4);
       			this.total = (parseFloat(this.totalc1)+parseFloat(this.totalc2)+parseFloat(this.totalc3)+parseFloat(this.totalc4)).toPrecision(4);

				   	if(cell == "r1c1")
					   this.r1c1p = ((this.r1c1/this.total)*100).toPrecision(3);

					else if(cell == "r1c2")
					   this.r1c2p = ((this.r1c2/this.total)*100).toPrecision(3);

					else if(cell == "r1c3")
					   this.r1c3p = ((this.r1c3/this.total)*100).toPrecision(3);
					else if(cell == "r1c4")
					   this.r1c4p = ((this.r1c4/this.total)*100).toPrecision(3);
					else if(cell == "r2c1")
					   this.r2c1p = ((this.r2c1/this.total)*100).toPrecision(3);
					else if(cell == "r2c2")
					   this.r2c2p = ((this.r2c2/this.total)*100).toPrecision(3);
					else if(cell == "r2c3")
					   this.r2c3p = ((this.r2c3/this.total)*100).toPrecision(3);
					else if(cell == "r2c4")
					   this.r2c4p = ((this.r2c4/this.total)*100).toPrecision(3);
					else if(cell == "r3c1")
					   this.r3c1p = ((this.r3c1/this.total)*100).toPrecision(3);
					else if(cell == "r3c2")
					   this.r3c2p = ((this.r3c2/this.total)*100).toPrecision(3);
					else if(cell == "r3c3")
					   this.r3c3p = ((this.r3c3/this.total)*100).toPrecision(3);
					else if(cell == "r3c4")
					   this.r3c4p = ((this.r3c4/this.total)*100).toPrecision(3);

						this.r1c1p = ((this.r1c1/this.total)*100).toPrecision(3);
						this.r1c2p = ((this.r1c2/this.total)*100).toPrecision(3);
						this.r1c3p = ((this.r1c3/this.total)*100).toPrecision(3);
						this.r1c4p = ((this.r1c4/this.total)*100).toPrecision(3);
						this.r2c1p = ((this.r2c1/this.total)*100).toPrecision(3);
						this.r2c2p = ((this.r2c2/this.total)*100).toPrecision(3);
						this.r2c3p = ((this.r2c3/this.total)*100).toPrecision(3);
						this.r2c4p = ((this.r2c4/this.total)*100).toPrecision(3);
						this.r3c1p = ((this.r3c1/this.total)*100).toPrecision(3);
						this.r3c2p = ((this.r3c2/this.total)*100).toPrecision(3);
						this.r3c3p = ((this.r3c3/this.total)*100).toPrecision(3);
						this.r3c4p = ((this.r3c4/this.total)*100).toPrecision(3);


					this.totalc1p = (parseFloat(this.r1c1p)+parseFloat(this.r2c1p)+parseFloat(this.r3c1p)).toPrecision(4);
this.totalc1 = (parseFloat(this.r1c1)+parseFloat(this.r2c1)+parseFloat(this.r3c1)).toPrecision(4);
this.totalc2p = (parseFloat(this.r1c2p)+parseFloat(this.r2c2p)+parseFloat(this.r3c2p)).toPrecision(4);
this.totalc2 = (parseFloat(this.r1c2)+parseFloat(this.r2c2)+parseFloat(this.r3c2)).toPrecision(4);
this.totalc3p = (parseFloat(this.r1c3p)+parseFloat(this.r2c3p)+parseFloat(this.r3c3p)).toPrecision(4);
this.totalc3 = (parseFloat(this.r1c3)+parseFloat(this.r2c3)+parseFloat(this.r3c3)).toPrecision(4);
this.totalc4p = (parseFloat(this.r1c4p)+parseFloat(this.r2c4p)+parseFloat(this.r3c4p)).toPrecision(4);
this.totalc4 = (parseFloat(this.r1c4)+parseFloat(this.r2c4)+parseFloat(this.r3c4)).toPrecision(4);

this.totalr1 = (parseFloat(this.r1c1)+parseFloat(this.r1c2)+parseFloat(this.r1c3)+parseFloat(this.r1c4)).toPrecision(4);
this.totalr1p = (parseFloat(this.r1c1p)+parseFloat(this.r1c2p)+parseFloat(this.r1c3p)+parseFloat(this.r1c4p)).toPrecision(4);
this.totalr2 = (parseFloat(this.r2c1)+parseFloat(this.r2c2)+parseFloat(this.r2c3)+parseFloat(this.r2c4)).toPrecision(4);
this.totalr2p = (parseFloat(this.r2c1p)+parseFloat(this.r2c2p)+parseFloat(this.r2c3p)+parseFloat(this.r2c4p)).toPrecision(4);
this.totalr3 = (parseFloat(this.r3c1)+parseFloat(this.r3c2)+parseFloat(this.r3c3)+parseFloat(this.r3c4)).toPrecision(4);
this.totalr3p = (parseFloat(this.r3c1p)+parseFloat(this.r3c2p)+parseFloat(this.r3c3p)+parseFloat(this.r3c4p)).toPrecision(4);

					this.total = (parseFloat(this.totalc1)+parseFloat(this.totalc2)+parseFloat(this.totalc3)+parseFloat(this.totalc4)).toPrecision(4);
					this.totalp = (parseFloat(this.totalc1p)+parseFloat(this.totalc2p)+parseFloat(this.totalc3p)+parseFloat(this.totalc4p)).toPrecision(3);
					}

					else{
						this.calculateSeed(cell);
					}

       		},

       		calculateSeed(cell){
       			console.log(cell);
       			this.totalc1 = (parseFloat(this.r1c1)).toPrecision(4);
       			this.totalc2 = (parseFloat(this.r1c2)).toPrecision(4);
       			this.totalc3 = (parseFloat(this.r1c3)).toPrecision(4);
       			this.total = (parseFloat(this.totalc1)+parseFloat(this.totalc2)+parseFloat(this.totalc3)).toPrecision(4);

       			if(cell == "r1c1")
					   this.r1c1p = ((this.r1c1/this.total)*100).toPrecision(3);

						else if(cell == "r1c2")
					   this.r1c2p = ((this.r1c2/this.total)*100).toPrecision(3);

						else if(cell == "r1c3")
					   this.r1c3p = ((this.r1c3/this.total)*100).toPrecision(3);

					  this.r1c1p = ((this.r1c1/this.total)*100).toPrecision(3);
						this.r1c2p = ((this.r1c2/this.total)*100).toPrecision(3);
						this.r1c3p = ((this.r1c3/this.total)*100).toPrecision(3);

						this.totalc1p = (parseFloat(this.r1c1p)).toPrecision(4);
						this.totalc1 = (parseFloat(this.r1c1)).toPrecision(4);

						this.totalc2p = (parseFloat(this.r1c2p)).toPrecision(4);
						this.totalc2 = (parseFloat(this.r1c2)).toPrecision(4);

						this.totalc3p = (parseFloat(this.r1c3p)).toPrecision(4);
						this.totalc3 = (parseFloat(this.r1c3)).toPrecision(4);

						this.totalr1 = (parseFloat(this.r1c1)+parseFloat(this.r1c2)+parseFloat(this.r1c3)).toPrecision(4);
						this.totalr1p = (parseFloat(this.r1c1p)+parseFloat(this.r1c2p)+parseFloat(this.r1c3p)).toPrecision(4);

						this.total = (parseFloat(this.totalc1)+parseFloat(this.totalc2)+parseFloat(this.totalc3)).toPrecision(4);
						this.totalp = (parseFloat(this.totalc1p)+parseFloat(this.totalc2p)+parseFloat(this.totalc3p)).toPrecision(3);
       		},

       		updateGrading(){
       			this.form.post("/api/updateGrading")
       			.then(response => {
       				this.getLotGrades();
       			})
       		},

       		updateModal(grade){
       			this.form.fill(grade);
       			$("#gradingsModal").modal("show");
       		},

       		deleteGrade(id){
       			axios.post("/api/deleteGrading", {id: id})
       			.then(response => {
       				this.getLotGrades();
       			})
       		},

       		getTemplate(){
       			this.getQualities();
       			axios.post("/api/getTemplates", {type: this.form.subtype})
        		.then(response => {
							this.row = response.data;
        		})
			},
			changeVals(grade, quality, value){
				for(var i = 0; i<this.vals.length; i++){
					if(this.vals[i].grade == grade && this.vals[i].quality == quality)
						this.vals[i].value = value;
				}
			},

			getColors(){
        axios.post("/api/getColors")
        .then(response => {
        	this.colors = response.data;
        })
      },

      getWarehouses(){
        axios.post("/api/getWarehouses")
        .then(response => {
        	this.warehouses = response.data;
        })
      },

      getSellers(){
      	axios.post("/api/getSellers")
      	.then(response => {
      		this.sellers = response.data;
      	})
      },

      updateLot(){
        this.form.post("/api/addLot")
        .then(() => {
        	axios.post("/api/getLotDetails", {id: this.$route.params.id})
       		.then(response => {
       			this.form.fill(response.data);
       			this.url = this.form.image_url;
       	   	this.errors = [];
        		toast.fire({
        			title: 'Lot Updated',
        			type: 'success'
        		});
        	})
        })
        .catch((errors) => {
        	this.errors = errors.response.data.errors;
        	toast.fire({
        		title: 'Operation Failed',
        		type: 'error'
        	});
        })
      },

      getTypes(){
        		axios.post("/api/getTypes")
        		.then(response => {
        			this.types = response.data;
        		})
        	},

        	getSubTypes(){
        		axios.post("/api/getSubTypes", {type: this.form.type})
        		.then(response => {
        			this.subtypes = response.data;
        		})
        	},

        	addFile(){
    				this.file = this.$refs.file.files[0];
    				this.image = this.file;
    				this.url = URL.createObjectURL(this.image);
    			},

    			changeImage(){
    				var formData = new FormData();
    				formData.set("id", this.form.id);
    				formData.append('image', this.image);
    				axios({
    					method: 'post',
    					url: '/api/changeImage',
    					data: formData,
    				})
        		.then(()=>{
      	     		toast.fire({
      		      	type: 'success',
                	title: 'Image Changed'
            		});
            		this.errors = [];
    				})
    				.catch((error)=>{
            	toast.fire({
      	      	type: 'error',
              	title: 'Operation Failed'
            	});
            	this.errors = error.response.data.errors;
          	})
    			},

    			getAuctions(){
    				axios.post("/api/getAvailableAuctions")
    				.then(response => {
    					this.auctions = response.data;
    				})
    			},

    			addLot(){
       			axios.post("/api/addAuctionLot", {auction_id: this.auction_id, lot_id: this.$route.params.id, created_by: this.$userId, updated_by: this.$userId})
       			.then(() => {
       				toast.fire({
       					title: 'Added to Auction',
       					type: 'success'
       				});
       			})
       			.catch(() => {
       				toast.fire({
       					title: 'Operation Failed',
       					type: 'error'
       				});
       			})
       	}
    }
  }
</script>
